import React from 'react';

import { useSearchResults } from '../../hooks';
import { SCOPE_ARTICLES } from '../../hooks/useSearchResults';
import { search_page_path } from '../../routes';
import { CustomToaster, Pagination, Spinner } from '../BaseUI';
import { PaginationType } from '../BaseUI/Pagination';
import { ExploreEntities, SearchBar } from '../shared';
import SearchHeader from './SearchHeader';
import SearchPostsList from './SearchPostsList';
import SearchSubscribersList from './SearchSubscribersList';
import SearchTabs from './SearchTabs';
import { SearchPageProps } from './index';
import styles from './styles.module.scss';

const FEED_COMPONENTS = {
  forum: SearchPostsList,
  directory: SearchSubscribersList,
};

const Layout = ({
  customBlurb,
  followCount,
  followers,
  followStatus,
  isSignedIn,
  matchingEntity,
  numArticleResults,
  page,
  query,
  scope,
  title,
  topEntities,
  topRelatedEntities,
}: SearchPageProps) => {
  const { data, isLoading } = useSearchResults(page, query, scope);

  if (isLoading) {
    return <Spinner />;
  }

  const isSearchLandingPage = !query && topEntities;

  const content = data?.profiles || data?.forum_posts || [];
  const numResults = scope === SCOPE_ARTICLES ? numArticleResults : data?.totalCount || 0;
  const FeedComponent = FEED_COMPONENTS[scope];

  const paginationData: PaginationType = {
    page,
    totalPages: data?.totalPages,
    hasNextPage: page < data?.totalPages,
    nextPage: page + 1,
  };

  return (
    <>
      <CustomToaster />
      <SearchBar
        isSearchLandingPage={isSearchLandingPage}
        placeholder={`Search ${scope || SCOPE_ARTICLES}`}
        scope={scope}
      />
      {isSearchLandingPage && <ExploreEntities entities={topEntities} isSignedIn={isSignedIn} />}
      {!!query && (
        <>
          <SearchHeader
            customBlurb={customBlurb}
            followCount={followCount}
            followers={followers}
            followStatus={followStatus}
            isSignedIn={isSignedIn}
            matchingEntity={matchingEntity}
            numResults={numResults}
            query={query}
            title={title}
            topRelatedEntities={topRelatedEntities}
          />
          <SearchTabs query={query} scope={scope} />
          <div className={styles.feedSection}>
            {FEED_COMPONENTS[scope] && <FeedComponent content={content} />}
          </div>
          {data?.totalPages > 1 && (
            <Pagination
              getPath={(page) => search_page_path({ query, scope, page })}
              paginationData={paginationData}
            />
          )}
        </>
      )}
    </>
  );
};

export default Layout;
